import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatAddress(fields: {
  address_line_1?: string | null;
  address_line_2?: string | null;
  city?: string | null;
  county?: string | null;
  postcode?: string | null;
}): string {
  return [
    fields.address_line_1,
    fields.address_line_2,
    fields.city,
    fields.county,
    fields.postcode,
  ]
    .filter(Boolean)
    .join(', ');
}
